import {useMemo} from 'react';
import {useFormContext} from 'react-hook-form';
import {
  getFormErrorsProgramatically,
  getIsTabWithErrors,
} from '../utils/errors';
import {PRODUCT_TABS} from '../constants';

export type ProductFormTab = {
  name: string,
};

const useFormTabErrors = (tabs: ProductFormTab[]) => {
  const {errors, formState} = useFormContext();

  const errorsByField = useMemo(() => {
    return getFormErrorsProgramatically(errors);
    // eslint-disable-next-line
  }, [errors, formState]);

  const tabWithErrors = useMemo(() => {
    const dratftErrors = [];

    for (const tabKey in tabs) {
      const evalFields = tabs[tabKey];

      const hasErrors = getIsTabWithErrors(evalFields, errorsByField);

      if (hasErrors) dratftErrors.push(tabKey);
    }

    const draftSectionKeys = [];

    for (const errorKey of dratftErrors) {
      const tab = PRODUCT_TABS.find(el => el.key === errorKey);

      if (tab) draftSectionKeys.push(tab);
    }

    return draftSectionKeys;
  }, [errorsByField, tabs]);

  return {errorsByField, tabWithErrors};
};

export default useFormTabErrors;
